import store from "store";

export const saveStoreValue = (key: string, value: string) => {
    if (!process.env.WEBPACK) return;
    const hwStorage = store.get("homework") || {};
    hwStorage[key] = value;
    store.set("homework", hwStorage);
};

export const getStoreValue = (key: string) => {
    if (!process.env.WEBPACK) return;
    const hwStorage = store.get("homework") || {};
    return hwStorage[key] as string;
};
